import {
    CREATE_REFUND_AMEND_APPLICATION_REQUEST,
    CREATE_REFUND_AMEND_APPLICATION_SUCCESS,
    CREATE_REFUND_AMEND_APPLICATION_FAIL,
    REFUND_AMEND_APPLICATION_REQUEST,
    REFUND_AMEND_APPLICATION_SUCCESS,
    REFUND_AMEND_APPLICATION_FAIL,
    FIND_REFUND_AMEND_APPLICATION_REQUEST,
    FIND_REFUND_AMEND_APPLICATION_SUCCESS,
    FIND_REFUND_AMEND_APPLICATION_FAIL,
    UPDATE_REFUND_AMEND_APPLICATION_REQUEST,
    UPDATE_REFUND_AMEND_APPLICATION_SUCCESS,
    UPDATE_REFUND_AMEND_APPLICATION_FAIL,
    CLEAR_REFUND_AMEND_APPLICATION_ERROR,
  } from "../../constants_Phase_2/RefundAndDisbursement/RefundAmendConstant";
  
  // create
  export const refundAmendReducer = (state = { refundAmendList: [] }, action) => {
    switch (action.type) {
      case  REFUND_AMEND_APPLICATION_REQUEST:
        return {
          ...state,
          loading: true,
          message: null,
          refundAmendList: [],
          status: null,
          error: null,
        };

        case CREATE_REFUND_AMEND_APPLICATION_REQUEST:
          case UPDATE_REFUND_AMEND_APPLICATION_REQUEST:
          return {
            ...state,
            loading: true,
            message: null,
            status: null,
            error: null,
          };


      case REFUND_AMEND_APPLICATION_SUCCESS:
        return {
          ...state,
          loading: false,
          refundAmendList: action.payload,
          totalData : action.totalData || 0,
          currentPage: action.currentPage,
          message: action.message,
          status: action.status,
        };


      case  CREATE_REFUND_AMEND_APPLICATION_SUCCESS:
        case  UPDATE_REFUND_AMEND_APPLICATION_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.message,
          status: action.status,
        };
  
      case REFUND_AMEND_APPLICATION_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case CREATE_REFUND_AMEND_APPLICATION_FAIL:
        case UPDATE_REFUND_AMEND_APPLICATION_FAIL:
        return {
          ...state,
          loading: false,
          refundAmendList: [...state.refundAmendList],
          message: action.message,
          status: action.status,
        };
  
      case CLEAR_REFUND_AMEND_APPLICATION_ERROR:
        return {
          ...state,
          error: null,
          status: null,
          message: null,
        };
  
      default:
        return state;
    }
  };

  // find one
export const findRefundAmendReducer = (state = { refundAmend: {} }, action) => {
    switch (action.type) {
        case FIND_REFUND_AMEND_APPLICATION_REQUEST:
            return {
                refundAmend: {},
                loading: true,
            };

        case FIND_REFUND_AMEND_APPLICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                refundAmend: action.payload,
            };

        case FIND_REFUND_AMEND_APPLICATION_FAIL:
            return {
                ...state,
                loading: false,
                refundAmend: {},
                error: action.payload
            };

        case "EMPTY_REFUND_AMEND_APPLICATION":
            return {
                ...state,
                refundAmend: {}
            }

        case CLEAR_REFUND_AMEND_APPLICATION_ERROR:
            return {
                ...state,
                error: null,
                status: null,
            };

        default:
            return state;
    }
};

    